export function OutlineShoppingCartSlashIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.50556 20.9999C10.3329 20.9999 11.0036 20.3292 11.0036 19.5019C11.0036 18.6746 10.3329 18.0039 9.50556 18.0039C8.67824 18.0039 8.00757 18.6746 8.00757 19.5019C8.00757 20.3292 8.67824 20.9999 9.50556 20.9999Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1574 18.1536C17.9653 18.0528 17.7445 18 17.5092 18C16.6834 18 16.0112 18.6722 16.0112 19.5028C16.0112 20.3334 16.6834 21.0008 17.5092 21.0008C18.335 21.0008 19.012 20.3334 19.012 19.5028C19.012 19.2675 18.9592 19.0467 18.8632 18.8546"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.12549 6.12695L14.0044 14.001H7.00412L6.12549 6.12695Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4.99805H21.0045L20.0682 14.0004H19.0024"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0047 20.9999L18.8586 18.8538L18.1528 18.148L14.0045 13.9997L6.12562 6.12562L3 3"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
